import * as types from "../types/actions/items"
import { findIndex } from "lodash"

const itemInitialState = {
  items: []
}

export default (state = itemInitialState, action) => {
  switch (action.type) {
    case types.ITEMS_SET:
      if (state.items.length > 0) {
        // the id of the item in the 0 index
        const firstIndexId = state.items[0].item_id
        // the index of the item with this id in the new array
        const indexInNewArray = findIndex(action.items, [
          "item_id",
          firstIndexId
        ])
        const newItemsArray = action.items.push(
          ...action.items.splice(0, indexInNewArray)
        )
        action.items.push(...action.items.splice(0, firstIndexId))
        return {
          ...state,
          items: action.items
        }
      } else {
        return {
          ...state,
          items: action.items
        }
      }
    case types.ITEMS_CLEAR:
      return {
        ...state,
        items: []
      }
    case types.ITEMS_MOVE:
      return {
        ...state,
        items: state.items.concat(state.items.splice(0, 5))
      }
    case types.ITEMS_ITEM_UPDATE:
      return {
        ...state,
        items: state.items.map(item => {
          if (item.item_id === action.item.item_id) {
            item = {
              ...item,
              ...action.item
            }
          }
          return item
        })
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/items.js